module.exports = __webpack_public_path__ + "img/md-appstore.f9892ac3.svg";